import template from './history.component.html';
import { clone } from '../../../utility/immutability.util.service';
import moment from 'moment';

import { orderBy } from 'lodash-es';

import * as HistoryActions from '../../../state/history/history.action';
import * as FavouriteActions from '../../../state/favourite/favourite.action';

export class AssetSearchHistoryController {
  constructor($ngRedux, gettextCatalog, gettext) {
    'ngInject';

    this.gettextCatalog = gettextCatalog;
    this.gettext = gettext;

    this.store = $ngRedux;

    this._toggleInProgress = false;

    this.meta = {};
    this.modifiedObject = {};
  }

  $onInit() {
    this.unsubscribe = this.store.connect(this.mapStateToThis, { ...HistoryActions, ...FavouriteActions })(this);
  }

  mapStateToThis(state) {
    const { favourites, history, search } = state;
    return {
      history: orderBy(history.list, history => moment(history.search.searchTime).toDate(), ['desc']),
      favourites: orderBy(favourites.list, favourite => moment(favourite.search.searchTime).toDate(), ['desc']),
      removedFavourites: favourites.removedList,
      search
    };
  }

  $onDestroy() {
    this.unsubscribe();
  }

  getMeta(searchItem) {
    if (searchItem == null) {
      return;
    }

    const { hash } = searchItem.search;
    if (!this.meta[hash]) {
      this.meta[hash] = {};
    }

    return this.meta[hash];
  }

  _preventBubbling($event) {
    $event.preventDefault();
    $event.stopPropagation();
  }

  _beginEdit(searchItem) {
    this._cancelEdit();
    const itemMeta = this.getMeta(searchItem);

    itemMeta.isEditing = true;
    this.modifiedObject = clone(searchItem);
  }

  _cancelEdit() {
    Object.keys(this.meta).forEach(key => {
      this.meta[key].isEditing = false;
      this.meta[key].isCreating = false;
      this.meta[key].isHistoryHovered = false;
    });
  }

  _beginDelete(searchItem) {
    this._cancelEdit(searchItem);
    const itemMeta = this.getMeta(searchItem);

    itemMeta.isDeleting = true;
    itemMeta.isHovered = false;
  }

  _cancelDelete(searchItem) {
    const itemMeta = this.getMeta(searchItem);

    itemMeta.isDeleting = false;
    itemMeta.isHovered = false;
  }

  _restore(searchItem) {
    this.favouriteRestore(searchItem.id);
  }

  _setItemError(searchItem, error) {
    const itemMeta = this.getMeta(searchItem);

    itemMeta.error = this.gettextCatalog.getString(error);
  }

  _hasName(searchItem) {
    return !!searchItem.name && searchItem.name.length > 0;
  }

  unFavourite($event, searchItem) {
    // prevent click from bubbling to avoid history closing when favourite is removed
    this._preventBubbling($event);
    this.favouriteRemove(searchItem);
    this._cancelDelete(searchItem);
  }

  editFavourite(searchItem) {
    this._beginEdit(searchItem);
  }

  saveFavourite() {
    if (!this.modifiedObject.name || this.modifiedObject.name === '') {
      this._setItemError(this.modifiedObject, this.gettext('You must provide a name to save a search favorite'));
      return;
    }

    this.favouriteAdd(this.modifiedObject);
    this._cancelEdit();
    // GTM UPDATE -> GTM UPDATED
    window.dataLayer.push({
      event: 'saveFavourite',
      favAttrs: {
        term: this.modifiedObject.name
      }
    })
  }

  renameFavourite() {
    if (!this.modifiedObject.name || this.modifiedObject.name === '') {
      this._setItemError(this.modifiedObject, this.gettext('You must provide a name to save a search favourite'));
      return;
    }

    this.favouriteUpdate(this.modifiedObject);
    this._cancelEdit();
  }

  cancelFavourite(searchItem) {
    this._cancelEdit(searchItem);
  }

  createFavourite(searchItem) {
    if (!searchItem.isFavourite) {
      this._beginEdit(searchItem);
      this.getMeta(searchItem).isCreating = true;
    }
  }

  toggleFavourite(searchItem) {
    this.editFavourite(searchItem);
  }

  _hasKeys(obj) {
    return obj && Object.keys(obj).length > 0;
  }

  hasHistory() {
    return this._hasKeys(this.history);
  }

  hasFavourites() {
    return this._hasKeys(this.favourites);
  }

  hasRecentDeletions() {
    return this._hasKeys(this.removedFavourites);
  }

  historyClicked(history) {
    this.selectHistory(history, this.favourites);
    this.closeHistory();
  }

  favouriteClicked(favourite) {
    this.favouriteSelect(favourite);
    this.closeHistory();
  }
}

export const assetSearchHistoryComponent = {
  template,
  bindings: {
    closeHistory: '&'
  },
  controller: 'AssetSearchHistoryController as vm'
};

export default assetSearchHistoryComponent;
